/* PW site stats: anonymous usage for pwc-admin's Site stats screen.
 * No cookies, no ids, nothing stored on the device. Only runs for visitors who accept analytics in the
 * cookie banner. Taps are sent as a position inside the section they land in, so heatmaps line up on any
 * screen width. With ?pw_heat=1&… (a signed link from Site stats) it draws the heatmap on the page instead. */
(() => {
  const C = window.PWT || {};
  if (!C.ep || (window.Shopify && window.Shopify.designMode)) return;
  const params = new URLSearchParams(location.search);
  const dev = innerWidth < 768 ? 'phone' : innerWidth < 1100 ? 'tablet' : 'desktop';
  const secKey = (el) => {
    const s = el && el.closest && el.closest('.shopify-section');
    return s && s.id ? s.id.replace(/^shopify-section-/, '').replace(/^.*__/, '') : '';
  };
  const secEl = (key) =>
    document.querySelector(`.shopify-section[id$="__${CSS.escape(key)}"]`) || document.getElementById('shopify-section-' + key);

  if (params.get('pw_heat') === '1') return heatmap();
  if (navigator.webdriver) return; // bots and automated browsers aren't counted

  /* ------------------------------------------------------------------ tracking */
  let on = false;
  const q = [];
  let maxDepth = 0;
  const push = (e) => {
    if (on && q.length < 120) q.push(e);
  };
  const flush = (final) => {
    if (final && maxDepth) {
      q.push({ t: 'scroll', d: Math.round(maxDepth) });
      maxDepth = 0;
    }
    if (!q.length) return;
    const body = JSON.stringify({ tpl: C.tpl, dev, ev: q.splice(0) });
    const url = C.ep + '/api/public/site/ev';
    if (!(navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' }))))
      fetch(url, { method: 'POST', body, keepalive: true, headers: { 'Content-Type': 'text/plain' } }).catch(() => {});
  };
  const label = (t) => {
    const el = t.closest('a,button,input,select,textarea,summary,label,[role="button"],[data-pw-track]');
    if (!el) return '';
    if (el.dataset.pwTrack) return el.dataset.pwTrack;
    const href = el.getAttribute('href') || '';
    if (/\/products\//.test(href)) return 'Card link';
    let s = el.getAttribute('aria-label') || (el.matches('input,textarea,select') ? el.placeholder || el.name || el.type : el.textContent) || '';
    s = s.replace(/\s+/g, ' ').trim().slice(0, 40);
    return s || el.tagName.toLowerCase();
  };
  function start() {
    if (on) return;
    on = true;
    const ref = document.referrer;
    let refHost = '';
    try {
      refHost = ref ? new URL(ref).hostname : '';
    } catch (e) {
      /* ignore */
    }
    const entry = !refHost || refHost.replace(/^www\./, '') !== location.hostname.replace(/^www\./, '');
    push({
      t: 'pv', entry, ref: entry && refHost ? 'https://' + refHost + '/' : '', utm: params.get('utm_source') || '',
      pid: C.pid || '', title: C.title || '', handle: C.handle || '',
      ...(C.q != null ? { q: C.q, results: C.results || 0 } : {}),
    });
    document.addEventListener('click', (e) => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      const s = t.closest('.shopify-section');
      const ev = { t: 'tap', el: label(t) };
      if (s) {
        const r = s.getBoundingClientRect();
        if (r.width && r.height) {
          ev.sec = secKey(s);
          ev.x = Math.round(((e.clientX - r.left) / r.width) * 100);
          ev.y = Math.round(((e.clientY - r.top) / r.height) * 100);
        }
      }
      push(ev);
    }, { capture: true, passive: true });
    const depth = () => {
      const h = document.documentElement.scrollHeight;
      if (h) maxDepth = Math.max(maxDepth, Math.min(100, ((scrollY + innerHeight) / h) * 100));
    };
    addEventListener('scroll', depth, { passive: true });
    depth();
    // add to cart, however the theme sends it
    const f = window.fetch;
    window.fetch = function (input, init) {
      try {
        const u = typeof input === 'string' ? input : input && input.url;
        if (/\/cart\/add/.test(u || '') && String((init && init.method) || (input && input.method) || 'GET').toUpperCase() === 'POST') push({ t: 'cart' });
      } catch (e) {
        /* ignore */
      }
      return f.apply(this, arguments);
    };
    document.addEventListener('submit', (e) => {
      if (e.target && /\/cart\/add/.test(e.target.getAttribute('action') || '')) push({ t: 'cart' });
    }, true);
    setInterval(() => flush(false), 10000);
    addEventListener('pagehide', () => flush(true));
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') flush(true);
    });
  }
  // only with consent: Shopify's customer privacy API (the cookie banner)
  const check = () => {
    const cp = window.Shopify && window.Shopify.customerPrivacy;
    if (cp && cp.analyticsProcessingAllowed && cp.analyticsProcessingAllowed()) start();
  };
  document.addEventListener('visitorConsentCollected', (e) => {
    if (e.detail && e.detail.analyticsAllowed) start();
  });
  if (window.Shopify && window.Shopify.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => {
      if (!err) check();
    });
  } else setTimeout(check, 1500);

  /* ------------------------------------------------------------------ heatmap view */
  function heatmap() {
    const qs = ['tpl', 'dev', 'days', 'exp', 'sig'].map((k) => k + '=' + encodeURIComponent(params.get(k) || '')).join('&');
    const bar = document.createElement('div');
    bar.style.cssText = 'position:fixed;left:50%;top:10px;transform:translateX(-50%);z-index:2147483001;background:#0e2d34;color:#fff;font:600 13px/1.3 system-ui,sans-serif;padding:7px 8px 7px 14px;border-radius:999px;display:flex;gap:10px;align-items:center;white-space:nowrap;box-shadow:0 6px 24px rgba(0,0,0,.25);max-width:calc(100vw - 20px)';
    bar.innerHTML = '<span data-t>Loading heatmap…</span><button type="button" data-h style="font:inherit;background:#fff;color:#0e2d34;border:0;border-radius:999px;padding:4px 10px;cursor:pointer">Hide</button>';
    document.body.appendChild(bar);
    const cv = document.createElement('canvas');
    cv.style.cssText = 'position:absolute;left:0;top:0;pointer-events:none;z-index:2147483000;mix-blend-mode:multiply';
    document.body.appendChild(cv);
    const badges = document.createElement('div');
    badges.style.cssText = 'position:absolute;left:0;top:0;width:0;height:0;z-index:2147483000;pointer-events:none';
    document.body.appendChild(badges);
    bar.querySelector('[data-h]').onclick = () => {
      const hidden = cv.style.display === 'none';
      cv.style.display = badges.style.display = hidden ? '' : 'none';
      bar.querySelector('[data-h]').textContent = hidden ? 'Hide' : 'Show';
    };
    let data = null;
    // warm sequential ramp: transparent -> yellow -> orange -> red
    const ramp = (() => {
      const c = document.createElement('canvas');
      c.width = 256;
      c.height = 1;
      const g = c.getContext('2d');
      const gr = g.createLinearGradient(0, 0, 256, 0);
      gr.addColorStop(0, 'rgba(255,237,160,0)');
      gr.addColorStop(0.25, 'rgba(254,217,118,.75)');
      gr.addColorStop(0.5, 'rgba(253,141,60,.85)');
      gr.addColorStop(0.75, 'rgba(240,59,32,.9)');
      gr.addColorStop(1, 'rgba(189,0,38,.95)');
      g.fillStyle = gr;
      g.fillRect(0, 0, 256, 1);
      return g.getImageData(0, 0, 256, 1).data;
    })();
    function draw() {
      if (!data) return;
      const W = document.documentElement.scrollWidth, H = Math.min(document.documentElement.scrollHeight, 30000);
      cv.width = W;
      cv.height = H;
      cv.style.width = W + 'px';
      cv.style.height = H + 'px';
      const g = cv.getContext('2d');
      const R = dev === 'phone' ? 16 : 22;
      let max = 1;
      const pts = [];
      badges.innerHTML = '';
      const total = data.taps || 1;
      for (const [key, list] of Object.entries(data.sections)) {
        const s = secEl(key);
        if (!s) continue;
        const r = s.getBoundingClientRect();
        if (!r.width || !r.height) continue;
        const top = r.top + scrollY, left = r.left + scrollX;
        let n = 0;
        for (const [rx, ry, c] of list) {
          pts.push([left + (rx / 100) * r.width, top + (ry / 100) * r.height, c]);
          max = Math.max(max, c);
          n += c;
        }
        const b = document.createElement('div');
        b.textContent = `${n.toLocaleString()} tap${n === 1 ? '' : 's'} · ${Math.round((n / total) * 100)}%`;
        b.style.cssText = `position:absolute;left:${left + r.width - 8}px;top:${top + 8}px;transform:translateX(-100%);background:rgba(14,45,52,.88);color:#fff;font:700 11px/1 system-ui,sans-serif;padding:5px 8px;border-radius:999px;white-space:nowrap`;
        badges.appendChild(b);
      }
      for (const [x, y, c] of pts) {
        const a = Math.min(1, 0.15 + (0.85 * c) / max);
        const gr = g.createRadialGradient(x, y, 0, x, y, R);
        gr.addColorStop(0, `rgba(0,0,0,${a})`);
        gr.addColorStop(1, 'rgba(0,0,0,0)');
        g.fillStyle = gr;
        g.fillRect(x - R, y - R, R * 2, R * 2);
      }
      const img = g.getImageData(0, 0, W, H);
      const d = img.data;
      for (let i = 3; i < d.length; i += 4) {
        const v = d[i];
        if (!v) continue;
        const o = v * 4;
        d[i - 3] = ramp[o];
        d[i - 2] = ramp[o + 1];
        d[i - 1] = ramp[o + 2];
        d[i] = ramp[o + 3];
      }
      g.putImageData(img, 0, 0);
    }
    fetch(C.ep + '/api/public/site/heat?' + qs)
      .then((r) => r.json())
      .then((j) => {
        if (j.error) throw new Error(j.error);
        data = j;
        const dn = { phone: 'Phones', tablet: 'Tablets', desktop: 'Desktop', all: 'All devices' }[j.dev] || j.dev;
        const tn = { index: 'Home', collection: 'Collection', product: 'Card page', search: 'Search', cart: 'Cart', 'page.sell-to-us': 'Sell page', 'page.me': 'Account' }[j.tpl] || j.tpl;
        bar.querySelector('[data-t]').textContent = `${tn} · ${dn} · ${j.days === 1 ? 'today' : j.days + ' days'} · ${j.taps.toLocaleString()} taps`;
        draw();
        [800, 2500, 6000].forEach((t) => setTimeout(draw, t));
        let rz;
        addEventListener('resize', () => {
          clearTimeout(rz);
          rz = setTimeout(draw, 200);
        });
      })
      .catch((e) => {
        bar.querySelector('[data-t]').textContent = e.message || 'Couldn’t load the heatmap';
      });
  }
})();
